const score = [
    [0, 0, 0, 0, 0],
    {
        'maxScore': 0,
        'maxIdx': 0 
    },
    [0, 0, 0, 0, 0]
];

export default score;